export default {
  title: 'Ficha Técnica',
  isLoading: false,
  isError: false,
  error: null,
  rowsPerPage: 10,
  valueTab: 0,
  firstLoad: false,
  // Atributos do filtro fornecedor
  fornecedores: [],
  fornecedor: 0,

  openModalUpFichaTecnica: false,
  opcoesSituacoes: [],

  opcoesFilial: [
    { id: 0, name: "Selecione uma filial" },
    { id: 1, name: "101 - Extrema - MG" },
    { id: 2, name: "40 - Jandira - SP" },
  ],

  opcoesFiltroPedidos: [
    { id: 0, description: 'Confirmação Agendamento Pendente', checked: false },
    { id: 1, description: 'Agendamento Confirmado', checked: false },
    { id: 2, description: 'Agendamento Recusado', checked: false },
    { id: 3, description: 'Entrega Concluída', checked: false },
  ],

  categoriaFornecedor: [],

  messageSnackbarFilterValidation: "",
  isOpenSnackbarFilterValidation: false,
};